const Container = (props) => <div className="mx-auto max-w-7xl px-1 sm:px-6 lg:px-8" {...props}/>

export default Container;